 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      GST Stat
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryGSTStatFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGSTStatFilterForm"
                            v-model="filters.gstStat"
                            :label="labels.gstStat"
                            :error-messages="errors.collect('filterGSTStat')"
                            data-vv-name="filterGSTStat"
                            :data-vv-as="labels.gstStat"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearGSTStatFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doGSTStatFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="headers"
          :items="gstStatList"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.value }}</td>
              <td>{{ row.item.label }}</td>
              <td align="center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignGSTStat(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      labels: {
        gstStat: 'GST Stat'
      },
      filters: {
        gstStat: undefined
      },
      headers: [
        { text: 'GST Stat', align: 'left', value: 'value' },
        { text: 'Description', align: 'left', value: 'label' },
        TableConst.tableActionHeader
      ],
      gstStatList: [],
      loading: false
    }
  },
  mounted() {
    this.doClearGSTStatFilters()
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.gstStatList = []
      try {
        const apiUrl = this.$store.state.commons.menu.gstStatList
        if (apiUrl) {
          const result = await this.$http.get(apiUrl)
          if (result && result.data && result.data.data) {
            this.gstStatList = result.data.data
          }
        }
      } catch (e) {
      }
      this.loading = false
    },
    closeDialog() {
      this.filters.gstStat = ''
      this.$emit('close')
    },
    doClearGSTStatFilters() {
      this.filters.gstStat = ''
      this.doFetch()
    },
    doGSTStatFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryGSTStatFilterForm').then((result) => {
        if (result) {
          this.doFetch()
        }
      })
    },
    assignGSTStat(data) {
      this.$emit('assign-gstStat', data.value)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
